import { CardActions, Skeleton } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~c/components/base/arranger';
import Card from '~c/components/base/card';
import { spc } from '~c/components/base/spacer';
import { useWindowSize } from '~c/hooks/use-hooks';

interface Props {
  className?: string;
  title?: string;
}

const MIN_GRAPH_HEIGHT = 184;

const GraphSkeleton: React.FC<Props> = ({ className, title }) => {
  const { height } = useWindowSize();
  const pieHeight = Math.max(MIN_GRAPH_HEIGHT, height / 5);

  return (
    <div className={className}>
      <Card title={title}>
        <Arranger
          className="pie-graph"
          alignItems="center"
          justify="center"
          sx={{ height: pieHeight }}
        >
          <Skeleton
            variant="circular"
            width={pieHeight * 0.8}
            height={pieHeight * 0.8}
          />
        </Arranger>
        <CardActions className="legend-container">
          <Arranger justify="space-around">
            {[1, 2, 3].map((_, idx) => (
              <Skeleton key={idx} variant="text" width={80} height={20} />
            ))}
          </Arranger>
        </CardActions>
      </Card>
    </div>
  );
};

export default muiStyled(GraphSkeleton)(({ theme }) => {
  return css`
    .legend-container {
      padding: ${theme.spacing(spc.m)} 0 0 0;

      > div {
        flex-grow: 1;
      }
    }
  `;
});
